import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import * as TbIcons from 'react-icons/tb';
import * as AiIcons from 'react-icons/ai';
import AuthService from "../services/auth.service";
import AxiosService from "../services/axios.service";
const API_PATH = "firms";

function ViewFirm({ history, match }) {

  const [firm, setFirm] = useState([]);
  const { id } = match.params;
  const [mod, setMod] = useState(false);
  const [admin, setAdmin] = useState(false);

  const styles = {
    div: {
      whiteSpace: "pre-line"
    }
  }

  useEffect(() => {
    const user = AuthService.getCurrentUser();
    if (user) {
      setMod(user.roles.includes("ROLE_MODERATOR"));
      setAdmin(user.roles.includes("ROLE_ADMIN"));
    }
    AxiosService.get(API_PATH, id).then(x => {
      var firm = x.data;
      setFirm(firm);
      console.log(firm);
    });
  }, []);

  return (

    <div>
      <h1 style={{ marginBottom: 25 }}>{firm.name}</h1>
      <table class="table">
        <div >
          <button style={{ position: 'sticky', left: 0, top: 25, zIndex: 1 }} onClick={() => history.goBack()}><TbIcons.TbArrowBack color='black' size={38} /></button>

        </div>
        <div style={{ position: 'sticky' }}>
          {(mod || admin) && (
            <Link to={`../edit/${id}`} style={{ position: 'relative', left: 0, top: -1, marginTop: 15 }} className="btn btn-sm btn-primary mr-2"> <AiIcons.AiTwotoneEdit size={22} /> </Link>
          )}
        </div>
        <thead>
          <tr>

          </tr>
        </thead>
        <tbody>
          <tr>
            <th scope="row">Firm Name:</th>
            <td>{firm.name}</td>
          </tr>

          <tr>
            <th scope="row">Street:</th>
            <td style={styles.div}>
              {firm.street}
            </td>
          </tr>

          <tr>
            <th scope="row">City:</th>
            <td>{firm.city}</td>
          </tr>

          <tr>
            <th scope="row">State:</th>
            <td style={styles.div}>{firm.state}</td>
          </tr>

          <tr>
            <th scope="row">Zip</th>
            <td style={styles.div}>{firm.zip}</td>
          </tr>

          <tr>
            <th scope="row">Website</th>
            <td><a target="_blank" rel="noreferrer noopener" href={"https://" + firm.website}>{firm.website}</a></td>
          </tr>

          <label>Attorneys</label>
          {firm.attorneys && firm.attorneys.map(attorney =>
            <tr key={attorney.id}>
              <td>
                <Link to={`/attorneys/view/${attorney.id}`} className="btn btn-sm btn-info mr-2"> {attorney.name} </Link>
              </td>
            </tr>
          )}

        </tbody>
      </table>
    </div >
  );

}

export { ViewFirm };